import { CatalogViewGroupBy } from '../view/catalogView.types';
import { ResolveCanManageSectionsParams } from './resolveCanManageSections.types';

export const resolveCanManageSections = ({
  appliedGroupBy,
  isCatalogSettled,
  isPreferencesSettled,
  canPersist,
  readMode,
  isAdminSeller,
}: ResolveCanManageSectionsParams): boolean =>
  isCatalogSettled &&
  isPreferencesSettled &&
  canPersist &&
  !readMode &&
  !isAdminSeller &&
  appliedGroupBy === CatalogViewGroupBy.MANUAL;
